import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import {
  ReconcileStripeSubscriptionsResponseDto,
  ReconcileZammadTicketsResponseDto,
} from '@workspace/data-types';
import { AuraWorkbenchComponent } from '@workspace/ng-aura';
import { environment } from '@workspace/ng-config';
import { AuthStore, UserStore } from '@workspace/ng-data-access';
import { ApiService } from '@workspace/ng-http';
import { finalize, tap } from 'rxjs';

@Component({
  selector: 'core-developer-workbench',
  imports: [AuraWorkbenchComponent, MatIcon, MatTabsModule, MatButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './developer-workbench.component.html',
})
export class DeveloperWorkbenchCoreComponent {
  private readonly apiService = inject(ApiService);
  private readonly authStore = inject(AuthStore);
  private readonly userStore = inject(UserStore);

  protected readonly environment = environment;
  protected readonly isAuthenticated = computed(() => this.authStore.isAuthenticated());
  protected readonly isAdmin = computed(() => this.userStore.isAdmin());

  isReconciling = signal(false);
  reconcileResult = signal<ReconcileStripeSubscriptionsResponseDto | null>(null);

  isReconcilingZammad = signal(false);
  zammadReconcileResult = signal<ReconcileZammadTicketsResponseDto | null>(null);

  reconcileStripe() {
    this.isReconciling.set(true);
    this.apiService
      .admin()
      .subscriptions()
      .reconcile(24)
      .pipe(
        tap({
          next: (res) => this.reconcileResult.set(res),
          error: (err) => console.error('Reconcile error', err),
        }),
        finalize(() => this.isReconciling.set(false)),
      )
      .subscribe();
  }

  reconcileZammad() {
    this.isReconcilingZammad.set(true);
    this.apiService
      .admin()
      .tickets()
      .reconcile(24)
      .pipe(
        tap({
          next: (res) => this.zammadReconcileResult.set(res),
          error: (err) => console.error('Zammad reconcile error', err),
        }),
        finalize(() => this.isReconcilingZammad.set(false)),
      )
      .subscribe();
  }
}
